import { useAdminPanelRouteConfig } from "@hooks/useAdminPanelRouteConfig";
import { Box } from "@mui/material";
import ViewFallback from "@views/ViewFallback";
import { useMemo } from "react";
import { Route, Routes } from "react-router-dom";

const ViewAdminPanel = () => {
  const adminPanelRoutes = useAdminPanelRouteConfig();

  const routes = useMemo(() => {
    return adminPanelRoutes.map((route) => (
      <Route path={route.path} Component={route.component} key={route.path} />
    ));
  }, [adminPanelRoutes]);

  return (
    <Box>
      <Routes>
        {routes}
        {/* Not found page */}
        <Route path="*" element={<ViewFallback variant="not-found" />} />
      </Routes>
    </Box>
  );
};

export default ViewAdminPanel;
